import React from "react";
import { Switch } from "react-router-dom";

import AppliedRoute from './AppliedRoutes/AppliedRoutes'
import SplitRoute from './AppliedRoutes/SplitRoute'
import AuthenticatedRoute from './AppliedRoutes/AuthenticatedRoute'
import AuthenticatedSplitRoute from './AppliedRoutes/AuthenticatedSplitRoute'
import DataRoute from './AppliedRoutes/DataRoute.js'
import SiteList, {LoadSites} from './Sites/SiteList';
import ResetPassword from './Login/ResetPassword'
import Account from './Account/Myaccount.js';
import NotFound from './NotFound/NotFound';
import NoAccess from './NotFound/NoAccess'; 
//import WaitTest from './WaitTest'

const Login = React.lazy(()=>import('./Login/Login'))
const ConfirmUser = React.lazy(()=>import('./Login/ConfirmUser'))
const Changes = React.lazy(()=> import('./Login/Changes'))
const GetStart = React.lazy(()=>import('./Login/GetStart'))
const CreateUser = React.lazy(()=>import('./Login/CreateUser'))
const VerifyUser = React.lazy(()=>import('./Login/VerifyUser'))
const Privacy = React.lazy(()=> import('./Login/Privacy'))
const FAQ = React.lazy(()=> import('./Help/FAQ'))
const SiteListEdit = React.lazy(()=>import('./SiteEdit/SiteListEdit'))
const GrantEdit = React.lazy(()=>import('./Grants/GrantEdit'))
const UserEdit = React.lazy(()=>import('./UserAdmin/UserEdit'))
const Billing = React.lazy(()=>import('./Billing/Billing.js'))
const Favorites = React.lazy(()=>import('./Favorites/EditFavorite.js'))

const rte = ({childProps}) => (
  <Switch>
    <SplitRoute exact path='/login' component={Login} props={childProps}/>
    <SplitRoute exact path='/privacy' component={Privacy} props={childProps}/>
    <AuthenticatedSplitRoute exact path='/whatsnew' component={Changes} props={childProps}/>
    <SplitRoute exact path='/GetStarted' component={GetStart} props={childProps}/>
    <SplitRoute exact path='/newacct' component={CreateUser} props={childProps}/>
    <SplitRoute exact path='/verify' component={VerifyUser} props={childProps}/>
    <SplitRoute exact path='/confirm' component={ConfirmUser} props={childProps}/>
    <AppliedRoute exact path='/resetpwd' component={ResetPassword} props={childProps}/>
    <AuthenticatedRoute exact path='/' component={SiteList} props={childProps} />
    <AuthenticatedSplitRoute exact path='/grants' component={GrantEdit} props={childProps}/>
    <AuthenticatedSplitRoute exact path='/user/edit' component={UserEdit} props={childProps}/>
    <AuthenticatedRoute exact path='/account' component={Account} props={childProps} />
    <AuthenticatedSplitRoute exact path='/billing' component={Billing} props={childProps} />
    <AuthenticatedRoute exact path='/access-denied' component={NoAccess} props={childProps} />
    <AuthenticatedSplitRoute exact path = '/sites' component={SiteListEdit} props={childProps} />
    <AuthenticatedSplitRoute exact path = '/favorites' component={Favorites} props={childProps} />
    <SplitRoute exact path='/FAQ' component={FAQ} />
    <AppliedRoute component={NotFound} props={childProps} /> 
  </Switch>
)

export default rte
//    //<DataRoute exact path='/' component={SiteList} props={childProps} load={LoadSites} cache={childProps.siteCache}/>

//     <AuthenticatedRoute exact path='/test' component={WaitTest} props={childProps} />

//import UserList from './UserAdmin/UserList';
//import SiteEdit from './SiteEdit/SiteEdit.js'
//import ClaimSite from './SiteEdit/ClaimSite.js';
//        <AuthenticatedRoute exact path='/customer/:orgId/sites' component={SiteEdit} props={childProps}/>
//    <AuthenticatedRoute exact path='/user/list' component={UserList} props={childProps}/>
/*
    <AuthenticatedRoute exact path='/claim' component={ClaimSite} props={childProps}/>
    <AuthenticatedRoute exact path='/requests' component={RequestGrant} props={childProps}/>
import WaitTest from './WaitTest'
    <AuthenticatedRoute exact path='/test' component={WaitTest} props={childProps} />
 */
